import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown'

import i18n from '../../utils/i18n'
import { PropertyIdentifierBodyTemplate } from './PropertyIdentifierBodyTemplate'

export const PropertyIdentifierFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  if (!options) return null

  const propertyIdentifiers: any[] = ['customer', 'supplier', 'thirdParties']

  const valueTemplate = (option: any, props: any) => {
    if (option) {
      return PropertyIdentifierBodyTemplate(option)
    }

    return <>{props.placeholder}</>
  }

  const itemTemplate = (option: any) => PropertyIdentifierBodyTemplate(option)

  return (
    <Dropdown
      value={options.value}
      options={propertyIdentifiers}
      onChange={(e: DropdownChangeEvent) =>
        options.filterCallback(e.value, options.index)
      }
      valueTemplate={valueTemplate}
      itemTemplate={itemTemplate}
      className="p-column-filter"
      placeholder={i18n.t('common.placeholders.search')}
    />
  )
}
